// globalRequestOverride.ts

let controllers: AbortController[] = [];

const DEFAULT_TIMEOUT = 300000;

export const cancelAllRequests = () => {
  controllers.forEach((c) => c.abort());
  controllers = [];
};

const originalFetch = window.fetch;

window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
  const controller = new AbortController();

  const timer = setTimeout(() => {
    controller.abort();
  }, DEFAULT_TIMEOUT);

  controllers.push(controller);

  const newInit: RequestInit = {
    ...init,
    signal: controller.signal,
  };

  return originalFetch(input, newInit).finally(() => {
    clearTimeout(timer);
    controllers = controllers.filter((c) => c !== controller);
  });
};